export default "/directory/static/engagement_shoots_available.71999853.svg";